import { RootState } from "../../../../../services/redux/app/store";
import { TransformOfferTypeObject } from "../../../../../services/redux/types/TypeHelper";
import { OfferCardSize } from "../../../../../utils/enums";
import Offer from "../../../../../utils/OfferClass/Offer/Offer";
import { RestaurantPackageOffer } from "../../../../../utils/types";
import { OfferCardV2 } from "../../../S-Cart/CartScreenOfferSection/OfferCard/OfferCardV2";

interface LegacyOfferCardsProps {
  offers: TransformOfferTypeObject<RestaurantPackageOffer>[];
  cartLoyaltyV2: RootState["cartLoyaltyV2Reducer"];
  itemStatusRedux: RootState["itemStatus"];
  orderTypeParam: RootState["queryParams"]["orderTypeParam"];
  restaurantInfo: RootState["config"]["restaurantInfo"];
  sourceOffers?: TransformOfferTypeObject<RestaurantPackageOffer>[];
  currentOffer?: Offer;
  displayPoints: number;
}

export const LegacyOfferCards = ({
  offers,
  cartLoyaltyV2,
  itemStatusRedux,
  orderTypeParam,
  restaurantInfo,
  sourceOffers = [],
  currentOffer,
  displayPoints,
}: LegacyOfferCardsProps) => (
  <>
    {offers.map((resOffer, index) => {
      const isApplicable =
        resOffer.packageOffer.isOfferApplicable({
          cart: cartLoyaltyV2.cart,
          itemStatusRedux,
          orderType: orderTypeParam,
          timeZone: restaurantInfo?.timeZone!,
        }) === true;
      const originalIndex = sourceOffers.indexOf(resOffer);
      const stableIndex = originalIndex >= 0 ? originalIndex : index;
      const isActive = resOffer.packageOffer.isEqual(currentOffer);
      const key = `${stableIndex}|pt:${
        resOffer.pointingMilestone?.points ?? "np"
      }|oos:${isApplicable ? 0 : 1}|act:${isActive ? 1 : 0}`;
      const pointsToUnlock = Math.max(
        (resOffer.pointingMilestone?.points || 0) - displayPoints,
        0
      );

      return (
        <OfferCardV2
          key={key}
          offer={resOffer.packageOffer}
          isActiveOffer={isActive}
          size={OfferCardSize.medium}
          pointsToUnlock={pointsToUnlock}
        />
      );
    })}
  </>
);
